<template lang="pug">
  .notifications-settings
    v-container.white.px-6(style="max-width:600px")
      v-layout.my-2
        div.mr-2
          v-icon.mt-1(left color="black" :size="24" @click="$router.push('/admin/settings')") mdi-arrow-left
        div.title.font-weight-bold {{ $t('notifications') }}

      v-layout.my-6(v-if="isFetching")
        v-row.fill-height.ma-0(align='center' justify='center')
          v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
      .content(v-else)
        v-card.pb-4.mt-4(flat style="border:1px solid var(--v-basic300); border-radius:0")
          v-card-title
            div
              .s1.primary500--text {{ $t('email_notifications') }}
              .c1.basic600--text {{ $t('receive_an_email') }}
          v-divider.basic300
          v-card-text.py-0
            v-row(align="center")
              v-col
                .label.basic600--text {{ $t('new_lead') }}
                .c1.basic600--text {{ $t('get_notified_leads') }}
              v-col.shrink
                y-switch.mr-n2.my-auto(v-model="data.settings.email.lead_created")
            v-row(align="center")
              v-col
                .label.basic600--text {{ $t('new_sales') }}
                .c1.basic600--text {{ $t('get_notified_sales') }}
              v-col.shrink
                y-switch.mr-n2.my-auto(v-model="data.settings.email.transaction_paid")
        v-card.pb-4.mt-4(flat style="border:1px solid var(--v-basic300); border-radius:0")
          v-card-title
            div
              .s1.primary500--text {{ $t('push_notifications') }}
              .c1.basic600--text.text-wrap {{ $t('receive_push_notification') }}
          v-divider.basic300
          v-card-text.py-0
            v-row(align="center")
              v-col
                .label.basic600--text {{ $t('new_lead') }}
                .c1.basic600--text {{ $t('get_notified_leads') }}
              v-col.shrink
                y-switch.mr-n2.my-auto(v-model="data.settings.push_notification.lead_created")
            v-row(align="center")
              v-col
                .label.basic600--text {{ $t('new_sales') }}
                .c1.basic600--text {{ $t('get_notified_sales') }}
              v-col.shrink
                y-switch.mr-n2.my-auto(v-model="data.settings.push_notification.transaction_paid")

</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'NotificationsSettings',
  props: ['company'],
  data () {
    return {
      isFetching: false,
      data: null
    }
  },
  computed: {
    ...mapState('user', ['member']),
  },
  mounted () {
    this.fetchSettings()
  },
  watch: {
    data: {
      deep: true,
      handler () {
        if (this.isFetching) {
          return
        }
        this.updateSettings()
      }
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    fetchSettings () {
      this.isFetching = true
      this.$axios.get(`/notifications/settings?member=${this.member.id}`)
        .then((response) => {
          this.data = response.data
        })
        .catch(() => {})
        .finally(() => {
          this.isFetching = false
        })
    },
    updateSettings () {
      this.axios.post(`/notifications/settings?member=${this.member.id}`, this.data)
        .catch(() => {})
    },
    clickOpenDownloadApp () {
      window.open('https://yezza.io/')
    }
  }
}
</script>

<style scoped>
</style>

<i18n>
{
  "en": {
    "notifications": "Notifications",
    "email_notifications": "Email Notifications",
    "receive_an_email": "Receive an email notification when below event is triggered",
    "new_lead": "New Lead",
    "get_notified_leads": "Get notified with incoming leads",
    "new_sales": "New Sales",
    "get_notified_sales": "Get notified with incoming sales",
    "push_notifications": "Push Notifications",
    "receive_push_notification": "Receive a push notification in Yezza App when below event is triggered"
  },
  "id": {
    "notifications": "Notifikasi",
    "email_notifications": "Notifikasi Email",
    "receive_an_email": "Dapatkan notifikasi email jika terdapat dibawah ini",
    "new_lead": "Lead baru",
    "get_notified_leads": "Dapat notifikasi dari lead yang masuk",
    "new_sales": "Penjualan baru",
    "get_notified_sales": "Dapat notifikasi dari penjualan yang masuk",
    "push_notifications": "Push Notifikasi",
    "receive_push_notification": "Dapatkan push notifikasi jika terdapat dibawah ini"
  }
}
</i18n>